import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import useApplicationStatus from "@/composables/application-status/useApplicationStatus";
import CustomDialogueModal from "@/components/modals/CustomDialogueModal.vue";
import useCustomDialogueModal from "@/composables/useCustomDialogueModal";
import useApplicationData from "@/composables/useApplicationData";
import { resolveMergeFields } from "@/use/formatter";
import { ButtonTypes } from "@/models/modal";


export default /*@__PURE__*/_defineComponent({
  __name: 'SLCRedirectButton',
  props: {
    openInNewTab: { type: Boolean }
  },
  emits: ["redirect"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const { isRedirecting, redirectToSLC } = useApplicationStatus();

const { emailAddress, hrefTFN, tollFreeNumber } = useApplicationData();

const { dialogueModalOptions, showDialogueModal, openDialogueModal, closeDialogueModal } =
  useCustomDialogueModal();

function onClick() {
  if (isRedirecting.value) return;

  try {
    redirectToSLC({ openInNewTab: false });
    isRedirecting.value = false;
  } catch {
    onError();
  }
}

function onError() {
  let error =
    "We couldn't take you to the Student Lending Center. Please refresh and try again. If the issue persists, please contact our support team at {{phoneNumber}} or {{email}}.";

  error = resolveMergeFields(error, {
    phoneNumber: `<a class="underline link" :href="\`tel:${hrefTFN.value}\`">${tollFreeNumber.value}</a>`,
    email: `<a class="underline link" :href="\`mailto:${emailAddress}\`">${emailAddress.value}</a>`,
  });

  showDialogueModal.value = false;

  dialogueModalOptions.value = {
    description: error,
    closeBtn: true,
    buttons: [
      {
        label: "Ok",
        type: Number(ButtonTypes.Confirm),
        onClick: async () => {
          closeDialogueModal();
          isRedirecting.value = false;
        },
      },
    ],
  };

  openDialogueModal(dialogueModalOptions.value);
}

__expose({
  redirectToSLC,
  onClick,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      onClick: _withModifiers(onClick, ["prevent"]),
      disabled: _unref(isRedirecting)
    }, _toDisplayString(_unref(isRedirecting) ? "Leaving Site..." : "Go to Student Lending Center"), 9, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_unref(showDialogueModal) === true)
        ? (_openBlock(), _createBlock(CustomDialogueModal, {
            key: 0,
            options: _unref(dialogueModalOptions),
            closeBtn: _unref(dialogueModalOptions).closeBtn,
            onClose: _unref(closeDialogueModal)
          }, null, 8, ["options", "closeBtn", "onClose"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})